import React from 'react';
import { Link } from 'react-router-dom';
import './VideoContentSection.css';

const VideoContentSection = ({ 
  title, 
  description, 
  videoSrc, 
  videoOnRight = false, 
  ctaButton,
  posterImage // Optional thumbnail image to show before video loads
}) => {
  return (
    <section className={`video-content-section ${videoOnRight ? 'video-right' : 'video-left'}`}>
      <div className="video-content-container">
        <div className="video-wrapper">
          <video
            autoPlay
            muted
            loop
            playsInline
            poster={posterImage}
          >
            <source src={videoSrc} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="video-content-text">
          <h2>{title}</h2>
          <p>{description}</p>
          {ctaButton && (
            <Link to={ctaButton.link} className="cta-button">
              {ctaButton.text}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};

export default VideoContentSection; 